import axios, { type AxiosInstance } from 'axios';
import { DB_BASE_URL } from '@/Constants';

const axiosClient: AxiosInstance = axios.create({
  baseURL: DB_BASE_URL,
});

export default async function loadNotionData() {
  try {
    const promises = [];
    promises.push(axiosClient.get('/modular_robots.json'));
    promises.push(axiosClient.get('/service_packages.json'));
    promises.push(axiosClient.get('/price_list.json'));
    return Promise.all(promises);

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    console.error(error);
    throw new Error(`Failed to load resources: ${error.message}`);
  }
}
